export const enumFromString = (theEnum: any, value: string): any => {
  for (const k in theEnum) {
    if (theEnum[k] === value) {
      return k
    }
  }
  console.log('This is not a real enum or string does not match!?', theEnum, value)
  throw new Error('This is not a real enum or string does not match!?')
}

export const boldSearchTerm = function (str: string, query: string) {
  // Find match and adds html tag, so it gets font-weight: bold
  // And keeps the original case
  // https://stackoverflow.com/questions/29896907/bold-part-of-string
  const n = str.toUpperCase();
  const q = query.toUpperCase();
  const x = n.indexOf(q);
  if (!q || x === -1) {
    return str;
  }
  const l = q.length;

  let strHtml = '';

  strHtml = str.substr(0, x) + '<strong>' + str.substr(x, l) + '</strong>' + str.substr(x + l);
  return '<p>' + strHtml + '</p>';
};